import axios from "axios";
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import ShoolfeeInvoice from "./ShoolfeeInvoice";
import FeatherIcon from "feather-icons-react";
import ShoolfeeInvoiceList from "./ShoolfeeInvoiceList";
import { toast } from "react-toastify";

const PAGE_SIZE_OPTIONS = [50, 100, 200];

class Schoolfees extends Component{

    state = {
        isModal : false,
        printInvoice : false,
        formData : null,
        students : [],
        input : [],
        loading : false,
        schoolfees : [],
        search : "",
        page : 1,
        pageSize : 100
    }

    componentDidMount(){
        this.orderBy();
    }

    showModalInvoice = (schoolfee = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : schoolfee,
        })
    }

    handleInput = (e) => {
        const schoolfee = e.target.value;
        this.setState((state) => ({
            input : state.input.some(item => item === schoolfee)
                ? state.input.filter(item => item !== schoolfee)
                : [...state.input, schoolfee]
        }))
    }

    handleSearch = (e) => {
        this.setState({ search : e.target.value, page : 1 })
    }

    handlePageSize = (e) => {
        this.setState({ pageSize : parseInt(e.target.value, 10), page : 1 })
    }

    setPage = (page) => {
        this.setState({ page });
    }

    async orderBy(){
        this.setState({ loading : false });
        var year = this.props.yearId ? "/year/" + this.props.yearId : "";
        var schoolfees = await axios.get("schoolfees" + year);

        if(schoolfees.status === 200)
        {
            this.setState({
                schoolfees : schoolfees.data.filter((schoolfee) => schoolfee.sectionschoolfeecategory),
                loading : true,
                page : 1
            })
        }
    }

    printInvoice = () => {
        this.setState({ printInvoice : !this.state.printInvoice })
    }

    delete = (schoolfee) =>{
        axios.delete("schoolfees/"+schoolfee).then((response) => {
            this.getStudents()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    getStudentName = (schoolfee) => {
        const user = schoolfee.student?.user;
        return [user?.last_name, user?.family_name, user?.first_name].filter(Boolean).join(" ");
    }

    getClassName = (schoolfee) => {
        const sectionclass = schoolfee.student?.sectionclass;
        return [sectionclass?.class?.short_entitled_class, sectionclass?.title, sectionclass?.section?.short_entitled_section].filter(Boolean).join(" ");
    }

    getPeriod = (schoolfee) => {
        return schoolfee.trimesectschool?.trimester?.short_trimester || schoolfee.month?.month || "";
    }

    getPaymentDate = (schoolfee) => {
        const date = schoolfee.operation === "Ajouter" ? schoolfee.createdAt : schoolfee.updatedAt;
        return date ? new Date(date)?.toLocaleDateString("en-GB") : "";
    }

    getFilteredSchoolfees = () => {
        const search = this.state.search.trim().toLowerCase();
        if(!search) return this.state.schoolfees;

        return this.state.schoolfees.filter((schoolfee) => {
            const values = [schoolfee.invoice, this.getStudentName(schoolfee), this.getClassName(schoolfee), schoolfee.pay_mount, this.getPeriod(schoolfee), schoolfee.year?.year, schoolfee.sectionschoolfeecategory?.schoolfeecategory?.category, this.getPaymentDate(schoolfee)];
            return values.join(" ").toLowerCase().includes(search);
        });
    }

    renderTableRows = (schoolfees) => {
        if(!this.state.loading){
            return (
                <tr>
                    <td colSpan={8} className="finance-ledger-state">
                        <FeatherIcon className="user-search-spin" icon="loader" /> Chargement des paiements...
                    </td>
                </tr>
            )
        }

        if(schoolfees.length === 0){
            return (
                <tr>
                    <td colSpan={8} className="finance-ledger-state">Aucun paiement trouve.</td>
                </tr>
            )
        }

        return schoolfees.map((schoolfee, index) => {
            const selected = this.state.input.some(item => String(item) === String(schoolfee.id));
            return (
                <tr key={schoolfee.id || index}>
                    <td>
                        <span className="schoolfees-list-invoice">
                            <input type="checkbox" onChange={this.handleInput} checked={selected} value={schoolfee.id} className="table_action" />
                            <a href={"/students/"+schoolfee.student?.id} className="text-decoration-none">{schoolfee.invoice}</a>
                        </span>
                    </td>
                    <td><span className="finance-ledger-account">{this.getStudentName(schoolfee)}</span></td>
                    <td>{this.getClassName(schoolfee)}</td>
                    <td className="finance-ledger-money is-balance">{schoolfee.pay_mount}{schoolfee.sectionschoolfeecategory?.currency || ""}</td>
                    <td>{this.getPeriod(schoolfee)}</td>
                    <td>{schoolfee.year?.year || ""}</td>
                    <td>{schoolfee.sectionschoolfeecategory?.schoolfeecategory?.category || ""}</td>
                    <td>
                        <span className="schoolfees-list-date">
                            {this.getPaymentDate(schoolfee)}
                            <button onClick={() => this.showModalInvoice(schoolfee)} className="btn btn-outline-primary rounded-3 btn-sm table_action" title="facture de ce enregistrement">
                                <FeatherIcon icon="file" size={15}></FeatherIcon>
                            </button>
                        </span>
                    </td>
                </tr>
            )
        })
    }

    render(){
        const filteredSchoolfees = this.getFilteredSchoolfees();
        const totalPages = Math.max(1, Math.ceil(filteredSchoolfees.length / this.state.pageSize));
        const page = Math.min(this.state.page, totalPages);
        const start = (page - 1) * this.state.pageSize;
        const pagedSchoolfees = filteredSchoolfees.slice(start, start + this.state.pageSize);
        const selectedTotal = this.state.input.length;

        return(
            <div className="finance-ledger-page schoolfee-recovery-page schoolfees-list-page">
                <div className="finance-ledger-hero schoolfee-recovery-hero">
                    <div className="finance-ledger-hero__title">
                        <span className="ev-dashboard__eyebrow">Caisse scolaire</span>
                        <h1>Liste des paiements eleves</h1>
                        <p>{this.state.loading ? `${filteredSchoolfees.length.toLocaleString()} paiement(s) affiche(s) sur ${this.state.schoolfees.length.toLocaleString()}` : "Chargement des paiements..."}</p>
                    </div>

                    <div className="finance-ledger-hero__actions schoolfee-recovery-filters schoolfees-list-filters">
                        <label className="finance-ledger-select schoolfees-list-search">
                            <FeatherIcon icon="search" size="16" />
                            <input type="search" value={this.state.search} onChange={this.handleSearch} placeholder="Rechercher facture, eleve, classe..." />
                        </label>
                        <label className="finance-ledger-select">
                            <FeatherIcon icon="list" size="16" />
                            <select value={this.state.pageSize} onChange={this.handlePageSize}>
                                {PAGE_SIZE_OPTIONS.map((size) => <option key={size} value={size}>{size} lignes</option>)}
                            </select>
                        </label>
                        <button type="button" className="btn btn-sm btn-outline-primary finance-ledger-print" onClick={() => this.orderBy()}>
                            <FeatherIcon icon="refresh-cw" size="17" /> <span>Actualiser</span>
                        </button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button"><FeatherIcon icon="printer" size="17" /> <span>Imprimer page</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </div>
                </div>

                <div className="finance-ledger-stats schoolfee-recovery-stats">
                    <article><span><FeatherIcon icon="file-text" size="17" /></span><div><strong>{this.state.schoolfees.length.toLocaleString()}</strong><small>Paiements</small></div></article>
                    <article><span><FeatherIcon icon="filter" size="17" /></span><div><strong>{filteredSchoolfees.length.toLocaleString()}</strong><small>Resultats</small></div></article>
                    <article><span><FeatherIcon icon="check-square" size="17" /></span><div><strong>{selectedTotal.toLocaleString()}</strong><small>Selection</small></div></article>
                    <article><span><FeatherIcon icon="layers" size="17" /></span><div><strong>{page}/{totalPages}</strong><small>Page</small></div></article>
                </div>

                <section className="finance-ledger-panel schoolfee-recovery-panel">
                    <div className="finance-ledger-panel__header">
                        <div>
                            <span>Paiements</span>
                            <h2>{this.state.search ? `Recherche: ${this.state.search}` : "Tous les paiements"}</h2>
                        </div>
                        <b>{this.state.loading ? `${start + (pagedSchoolfees.length ? 1 : 0)}-${start + pagedSchoolfees.length} / ${filteredSchoolfees.length}` : "Chargement..."}</b>
                    </div>

                    <div ref={el => (this.componentRef = el)}>
                        <Headerpdf />
                        <UserIdentity title={"Liste des paiements eleves"} />
                        <div className="table-responsive finance-ledger-table-wrap schoolfees-list-table-wrap">
                            <table className="table table-sm finance-ledger-table schoolfees-list-table">
                                <thead>
                                    <tr>
                                        <th>Fact</th>
                                        <th>Eleve</th>
                                        <th>Classe</th>
                                        <th>Montant</th>
                                        <th>Trimestre</th>
                                        <th>Annee</th>
                                        <th>Frais</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderTableRows(pagedSchoolfees)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="schoolfees-list-pagination">
                        <button type="button" className="btn btn-sm btn-outline-primary" disabled={page <= 1} onClick={() => this.setPage(page - 1)}>
                            <FeatherIcon icon="chevron-left" size={15} /> Precedent
                        </button>
                        <span>Page {page} sur {totalPages}</span>
                        <button type="button" className="btn btn-sm btn-outline-primary" disabled={page >= totalPages} onClick={() => this.setPage(page + 1)}>
                            Suivant <FeatherIcon icon="chevron-right" size={15} />
                        </button>
                    </div>
                </section>

                {selectedTotal > 0 && (
                    <div className="schoolfees-list-selection">
                        <span>{selectedTotal} facture(s) selectionnee(s)</span>
                        <button className="btn btn-primary btn-sm" onClick={() => this.printInvoice() }>
                            <FeatherIcon icon="printer" size={15} /> Imprimer la selection
                        </button>
                    </div>
                )}

                {this.state.formData &&  (this.state.formData.id && (
                    <ShoolfeeInvoice
                        isModal={this.state.isModal}
                        formData={this.state.formData.id}
                        schoolfeecategory={this.state.schoolfeecategory}
                        showModal={this.showModalInvoice}
                    />
                ))}

                {selectedTotal > 0 && (
                    <ShoolfeeInvoiceList
                        isModal={this.state.printInvoice}
                        formData={this.state.input}
                        showModal={this.printInvoice}
                    />
                )}
            </div>
        )
    }
}
export default Schoolfees;
